import styled from 'styled-components';
import { Select } from '../shared/styled-components';
import Colors from '../../../../styles/colors';
import { fade, BaseButton } from '../../../../styles/styled';

export const SoundcastSelectWrapper = styled.div`
  width: 100%;
  display: inline-block;
`;

export const SoundcastSelect = styled(Select)`
  background-color: ${Colors.mainWhite};
  margin: 0;
  font-size: 1.6rem;
  border-radius: 5px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 5px;
`;

export const SubsToggleLabel = styled.span`
  font-size: 1.5rem;
  font-weight: 800;
  margin: 0 10px;

  @media only screen and (max-width: 576px) {
    margin-left: 0.5rem;
  }

  @media only screen and (min-width: 768px) {
    font-size: 1.8rem;
  }

  @media only screen and (min-width: 992px) {
    font-size: 1.8rem;
  }
`;

export const PublishBtn = styled(BaseButton)`
  float: right;
  border-radius: 20px;
  font-size: 14px;
  letter-spacing: 2.5px;

  @media only screen and (max-width: 768px) {
    margin-top: 20px;
    width: 100%;
  }
`;

export const ListMessage = styled.div`
  background-color: ${Colors.mainWhite};
  margin: 8px 0;
  border-radius: 8px;
  animation: ${fade(0, 1)} 0.2s ease-in;
  position: relative;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  &.fadeDelete .msg-wrapper {
    animation: ${fade(1, 0.3)} 0.5s normal forwards cubic-bezier(0.4, 0, 0.2, 1);
  }

  &.fadeDelete .msg-overlay {
    display: block;
  }

  .msg-overlay {
    display: none;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    .msg-overlay-content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
  }

  .msg-wrapper {
    padding: 20px;
    font-size: 1.6rem;

    .msg-header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .msg-date {
        font-weight: 700;

        @media only screen and (max-width: 576px) {
          font-size: 1.4rem;
        }
      }

      .del-btn {
        border: 1px solid ${Colors.mainOrange};
        background: ${Colors.mainOrange};
        color: #fff;
        width: 26px;
        height: 26px;
        min-width: 26px;
        min-height: 26px;
        border-radius: 13px;
        font-size: 1.4rem;
        margin-left: 5px;

        &:hover {
          background-color: #f75d04;
        }
      }
    }

    .msg-content {
      padding: 10px 0;
    }

    .msg-footer {
      font-size: 1.4rem;
      text-align: right;
    }
  }
`;

export const AnnouncementTextArea = styled.textarea`
  height: 150px;
  font-size: 1.6rem;
  border-radius: 5px;
  resize: vertical;
  margin: 0
`;

export const Noresult = styled.div`
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
`;
